import { Component, ViewChild, OnInit,Input,Output,EventEmitter } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { AnalisisDeBrechasService } from '../../../services/analisis-de-brechas.service';
import { TablaDeEvaluacionService } from '../../../services/tabla-de-evaluacion.service';
import { MarcoDeReferenciaService } from 'app/main/services/marco-de-referencia.service';
import { TokenStorageService } from 'app/main/auth/token-storage.service';
import { MatStepper } from '@angular/material/stepper';
import {MatSnackBar} from '@angular/material/snack-bar';
import {TranslateService} from '@ngx-translate/core';
import { DialogAnalisisBoxPrintComponentAnalisisDeBrechas} from '../dialog/dialog-analisis-print-box.component';
import { DialogAnalisisBoxAnalyticsComponentAnalisisDeBrechas} from '../dialog/dialog-analisis-analytics-box.component';
import { UtilsService } from '../../../services/utils.service';
import { Sentencia } from 'app/main/models/sentencia.model';
import { MarcoDeReferencia } from 'app/main/models/marco-de-referencia.model';

import { TablaDeEvaluacion } from 'app/main/models/tabla-de-evaluacion.model';

import {FlatTreeControl} from '@angular/cdk/tree';
import {MatTreeFlatDataSource, MatTreeFlattener} from '@angular/material/tree';

interface ExampleFlatNode {
  expandable: boolean;
  name: string;
  //descripcion: string;
  level: number;
}

@Component({
    selector   : 'sentencia-tree',
    templateUrl: './sentencia-tree.component.html',
    styleUrls  : ['./sentencia-tree.component.scss']
})
export class SentenciaTreeComponent
{
  @Input() dataSource: Sentencia;
  @Input() tablaDeAnalisisDeBrechas:TablaDeEvaluacion; 
  @Input() analisisDeBrechasEstado:string;
  @Input() isResponsable: boolean;
  @Input() printable: boolean;

  @Output("loadData") loadData: EventEmitter<any> = new EventEmitter();
  
  private _transformer = (node: Sentencia, level: number) => {
    return {
      expandable: !!node.sentencias && node.sentencias.length > 0,
      name: node.nombre,
      level: level,
      descripcion: node.descripcion,
      valor: node.valor,
      id: node.id,
      valores: node.valores,
      opcion: node.opcion,
      adjuntos: node.adjuntos,
      cumpleNoCumple: node.cumpleNoCumple,
      sentencias: node.sentencias
    };
  }

  treeControl = new FlatTreeControl<ExampleFlatNode>(
      node => node.level, node => node.expandable);

  treeFlattener = new MatTreeFlattener(
      this._transformer, node => node.level, node => node.expandable, node => node.sentencias);

  dataSourceTree = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

    dataSourceList = [];

    is_eval_owner = false;
    is_admin = false;

    fechaFin = null;
    editar_dueno = true;
    es_multiple = false;

    @ViewChild('stepper') private stepper: MatStepper;

    //@ViewChild("stepper") stepper: MatStepper;


    constructor(public dialog: MatDialog,
                private storage: TokenStorageService,
                private service: AnalisisDeBrechasService,
                public serviceTablasDeEvaluacionService:TablaDeEvaluacionService,
                public serviceMarcoDeReferenciaService:MarcoDeReferenciaService,
                private _snackBar: MatSnackBar,
                public translate: TranslateService,
                public router: Router,
                public utils:UtilsService,
                private route: ActivatedRoute) {

                }

    
    ngOnInit() {

      if(this.tablaDeAnalisisDeBrechas.tipo==="EVALUACION_MULTIPLE")
        this.es_multiple = true;

      if(this.dataSource!=null){
        this.dataSourceList = this.dataSource.sentencias;
        this.orderStructure(this.dataSourceList);
        this.dataSourceTree.data = this.dataSourceList;
      }

      this.treeControl.expandAll();

      //this.aplanar();

    }

    hasChild = (_: number, node: ExampleFlatNode) => node.expandable;


    print():void{

      const dialogRef = this.dialog.open(DialogAnalisisBoxPrintComponentAnalisisDeBrechas, {
        panelClass: 'my-full-screen-dialog',
        width: '95%',
        maxWidth: '95%',
        data: {action:"Print", obj:this.dataSource},
        autoFocus: false,
        disableClose: true
      });

    }

    viewStatistics(sentencias,nivel,esMatrizReverso):void{
      //DialogAnalisisBoxPrintComponentAnalisisDeBrechas
      
      const dialogRef = this.dialog.open(DialogAnalisisBoxAnalyticsComponentAnalisisDeBrechas, {
        panelClass: 'my-full-screen-dialog',
        width: '95%',
        maxWidth: '95%',
        data: {action:"Print", 
              obj:sentencias,
              nivel: nivel,
              tablaDeAnalisisDeBrechas:this.tablaDeAnalisisDeBrechas,
              esMultiple: this.es_multiple,
              esMatrizReverso: esMatrizReverso},
        autoFocus: false,
        disableClose: true
      });
    }

    reloadData():void{
    }

    openSnackBar(message: string, action: string) {
      this._snackBar.open(message, action, {
        duration: 3000,
      });
    }


    compareObjects(o1: any, o2: any): boolean {
      var equals = false;
      if(o1!=null && o2!=null)
        equals = o1.nombre === o2.nombre && o1.id === o2.id
      return equals;
    }

    orderStructure(sentencias):void{
      if(sentencias!=null)
        for(var z=0; sentencias.length>z;z++){
          sentencias.sort(this.utils.sortAlphaNum);
          //sentencias.sort((a, b) => (a.nombre > b.nombre) ? 1 : -1);
          this.orderStructure(sentencias[z].sentencias);
        }
    }

    formatDescription(description: string): string {
        return description ? description.replace(/\n/g, '<br>') : '';
    }



}
